/**
 * Shopify contact forms (Sell, Contact) → Klaviyo identify + track after successful submit.
 * identify = profile properties; track = Activity / Events in Klaviyo.
 */
(function () {
  const SECTION_SELECTOR = '[data-botr-klaviyo-contact]';

  const DEFAULT_EVENTS = {
    sell: 'Submitted Sell Watch Form',
    contact: 'Submitted Contact Form',
    service: 'Submitted Service Watch Form'
  };

  function waitForKlaviyo(callback, attempt) {
    const tries = attempt || 0;
    if (window.klaviyo && typeof window.klaviyo.push === 'function') {
      callback();
      return;
    }
    if (tries < 60) {
      setTimeout(() => waitForKlaviyo(callback, tries + 1), 100);
    }
  }

  function storageKey(section) {
    return 'botr.klaviyo.contact.' + (section.dataset.botrKlaviyoContact || 'default');
  }

  function readFormPayload(form, section) {
    const getValue = (name) => form.querySelector(`[name="${name}"]`)?.value?.trim() || '';
    const formType = section.dataset.botrKlaviyoContact || 'sell';

    return {
      email: getValue('contact[email]'),
      firstName: getValue('contact[First Name]'),
      lastName: getValue('contact[Last Name]'),
      phone: getValue('contact[phone]'),
      photoLink: getValue('contact[Photo Link]'),
      message: getValue('contact[body]'),
      sourcePage: section.dataset.botrKlaviyoSource || '',
      formType: formType,
      eventName:
        section.dataset.botrKlaviyoEvent || DEFAULT_EVENTS[formType] || DEFAULT_EVENTS.sell
    };
  }

  function trackEvent(eventName, properties) {
    if (typeof window.klaviyo?.track === 'function') {
      window.klaviyo.track(eventName, properties);
      return;
    }

    window.klaviyo = window.klaviyo || [];
    window.klaviyo.push(['track', eventName, properties]);

    const learnq = window._learnq || [];
    if (learnq !== window.klaviyo) {
      learnq.push(['track', eventName, properties]);
    }
  }

  function sendToKlaviyo(payload) {
    if (!payload.email) return;

    const identifyProps = {
      email: payload.email,
      $email: payload.email,
      first_name: payload.firstName,
      $first_name: payload.firstName,
      last_name: payload.lastName,
      $last_name: payload.lastName,
      phone_number: payload.phone,
      $phone_number: payload.phone
    };

    const trackProps = {
      source_page: payload.sourcePage,
      form_type: payload.formType,
      first_name: payload.firstName,
      last_name: payload.lastName,
      phone: payload.phone,
      message: payload.message
    };

    if (payload.formType === 'contact') {
      identifyProps.contact_message = payload.message;
      identifyProps.last_contact_form_source = payload.sourcePage;
    } else if (payload.formType === 'service') {
      identifyProps.service_photo_link = payload.photoLink;
      identifyProps.service_details = payload.message;
      identifyProps.last_service_form_source = payload.sourcePage;
      trackProps.photo_link = payload.photoLink;
      trackProps.service_details = payload.message;
    } else {
      identifyProps.sell_photo_link = payload.photoLink;
      identifyProps.sell_details = payload.message;
      identifyProps.last_sell_form_source = payload.sourcePage;
      trackProps.photo_link = payload.photoLink;
      trackProps.sell_details = payload.message;
    }

    const eventName = payload.eventName;

    let tracked = false;
    const runTrackOnce = () => {
      if (tracked) return;
      tracked = true;
      trackEvent(eventName, trackProps);
    };

    if (typeof window.klaviyo?.identify === 'function') {
      const result = window.klaviyo.identify(identifyProps, runTrackOnce);
      if (result && typeof result.then === 'function') {
        result.then(runTrackOnce).catch(runTrackOnce);
      }
      return;
    }

    window.klaviyo = window.klaviyo || [];
    window.klaviyo.push(['identify', identifyProps]);
    const learnq = window._learnq || [];
    if (learnq !== window.klaviyo) {
      learnq.push(['identify', identifyProps]);
    }
    setTimeout(runTrackOnce, 500);
  }

  function initSection(section) {
    const form = section.querySelector('.botr-contact__form');
    if (!form) return;

    const key = storageKey(section);

    form.addEventListener('submit', () => {
      try {
        sessionStorage.setItem(key, JSON.stringify(readFormPayload(form, section)));
      } catch {
        /* private browsing */
      }
    });

    const successMessage = section.querySelector('.botr-contact__msg--success');
    if (!successMessage) return;

    let payload;
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return;
      payload = JSON.parse(raw);
      sessionStorage.removeItem(key);
    } catch {
      return;
    }

    if (!payload || !payload.email) return;

    waitForKlaviyo(() => sendToKlaviyo(payload));
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
